import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { MatSelectChange } from '@angular/material/select'

import { I18nService, LanguageListType, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-lang-select',
  templateUrl: './bmcore-lang-select.component.html',
  styleUrls: ['./bmcore-lang-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLangSelectComponent implements OnInit {
  lg: LgType
  language: string
  languageList: LanguageListType[] = []

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.language = this.i18nService.language
    this.lg = this.i18nService.getLanguageForPage()

    this.languageList = [
      { key: 'ru', descr: this.lg.footer.language.ru },
      { key: 'en', descr: this.lg.footer.language.en }
    ]
  }

  changeLanguage(selectValue: MatSelectChange) {
    this.language = selectValue.value
    this.i18nService.setLanguage(this.language)
    window.location.reload()
  }
}
